import { render, staticRenderFns } from "./ItemFichaTecnica.vue?vue&type=template&id=5eba6da2&scoped=true&"
import script from "./ItemFichaTecnica.vue?vue&type=script&lang=js&"
export * from "./ItemFichaTecnica.vue?vue&type=script&lang=js&"
import style0 from "./ItemFichaTecnica.vue?vue&type=style&index=0&id=5eba6da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eba6da2",
  null
  
)

export default component.exports